import { Badge, Box, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export default function SubcaseBadge({
  count,
  title,
}: {
  count: ReactNode;
  title: string;
}) {
  const { t } = useTranslation();

  return (
    <Badge badgeContent={count} color="primary" overlap="rectangular">
      <Box component="span" sx={{ p: ".2rem" }}>
        <Typography>{t(title)}</Typography>
      </Box>
    </Badge>
  );
}
